/**
 * Constants for report parameters and dynamic options
 */
export const DYNAMIC_OPTIONS = {
  IE_KITS: 'ie-kits',
} as const;

export type DynamicOptionType = (typeof DYNAMIC_OPTIONS)[keyof typeof DYNAMIC_OPTIONS];
